import { Toast, ToastContainer } from "react-bootstrap";

function Toaster(props) {
  return (
    <ToastContainer position="middle-right" style={{ zIndex: 1 }}>
      {props.saved ? (
        <></>
      ) : (
        <Toast
          className="d-inline-block m-1"
          bg="warning"
          onClose={props.clearSaveWarning}
        >
          <Toast.Header closeButton={false}>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">Warning</strong>
            <small>💾</small>
          </Toast.Header>
          <Toast.Body>Your changes are unsaved.</Toast.Body>
        </Toast>
      )}
      {props.saving ? (
        <Toast className="d-inline-block m-1" bg="primary">
          <Toast.Header closeButton={false}>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">Saving Changes...</strong>
            <small>hi.</small>
          </Toast.Header>
          <Toast.Body>Your changes are being saved...</Toast.Body>
        </Toast>
      ) : (
        <></>
      )}
      {props.error ? (
        <Toast
          className="d-inline-block m-1"
          bg="danger"
          onClose={props.clearError}
        >
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">Error</strong>
            <small>oops.</small>
          </Toast.Header>
          <Toast.Body>
            There was an error while performing your request: {props.error}
          </Toast.Body>
        </Toast>
      ) : (
        <></>
      )}
      {!props.loaded ? (
        <Toast className="d-inline-block m-1" bg="warning">
          <Toast.Header closeButton={false}>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">Loading Data...</strong>
            <small>👩🏻‍💻</small>
          </Toast.Header>
          <Toast.Body>Please wait while we load the problem record.</Toast.Body>
        </Toast>
      ) : (
        <></>
      )}
      {props.message ? (
        <Toast className="d-inline-block m-1" bg="info">
          <Toast.Header closeButton={false}>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">For Your Information...</strong>
            <small>sup.</small>
          </Toast.Header>
          <Toast.Body>{props.message}</Toast.Body>
        </Toast>
      ) : (
        <></>
      )}
      {props.archived ? (
        <Toast className="d-inline-block m-1" bg="dark">
          <Toast.Header closeButton={false}>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">Archived</strong>
            <small>⚠️</small>
          </Toast.Header>
          <Toast.Body className="text-white">
            ☠️ This PRB has been archived and cannot be modified.
          </Toast.Body>
        </Toast>
      ) : (
        <></>
      )}
    </ToastContainer>
  );
}

export default Toaster;
